<template>
  <section>
    <resource
      title="Ändern"
      resource="coupon"
      resourceName="Gutschein"
      :original="original"
      :attributes="[
        {
          name: 'slug',
          label: 'Code',
          type: 'CodeSelector'
        },
        {
          name: 'start',
          label: 'Start',
          type: 'DateTimeSelector'
        },
        {
          name: 'end',
          label: 'Ende',
          type: 'DateTimeSelector'
        },
        {
          name: 'amount',
          label: 'Menge an Coins'
        },
        {
          name: 'for_one',
          label: 'Einmal einlösbar?',
          type: 'CheckboxSelector'
        },
        {
          name: 'active',
          label: 'Aktiv?',
          type: 'CheckboxSelector'
        }
      ]"
    >
      <div slot="title">
        <h4>Gutschein bearbeiten</h4>
      </div>
    </resource>
  </section>
</template>

<script lang="babel">
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('coupon/read', [
      {
        name: 'where',
        attributes: {
          id : [Number(to.params.id)],
        }
      },
    ]).then(() => {
      next();
    });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['coupon/find'](this.id);
    },
    updateUrl() {
      return this.original !== undefined ? this.original.update_url : "";
    }
  }
}
</script>
